import {
  FILLING_CODE_OPTIONS,
  INCOME_ESTIMATE_OPTIONS,
  US_STATES_OPTIONS
} from "../../constants/user";

export function formatFilingCode(filingCode?: string) {
  return FILLING_CODE_OPTIONS.find(option => option.value === filingCode)
    ?.label;
}

export function formatIncomeEstimate(incomeEstimate?: number) {
  return INCOME_ESTIMATE_OPTIONS.find(option => option.value === incomeEstimate)
    ?.label;
}

export function formatStateOfResidence(stateOfResidence?: string) {
  return US_STATES_OPTIONS.find(option => option.value === stateOfResidence)
    ?.label;
}
